// extracted by mini-css-extract-plugin
export default {"wrapper":"_0aYKV0G1--SummaryLayout_wrapper__pVyTk","wiggle":"_0aYKV0G1--SummaryLayout_wiggle__uXRhy","shimmer":"_0aYKV0G1--SummaryLayout_shimmer__4NMqM"};